import {API} from 'common/api';
import {isbot} from 'isbot';

/**
 * Record that this visitor was shown a variant of an experiment.
 *
 * The backend fingerprints the caller by session or by the `attr` cookie (minted for
 * every visitor in `proxy.ts`) and dedupes per fingerprint, so calling this on every
 * render of a gated surface is safe.
 *
 * Crawlers are skipped, the same way `iq-tracking` skips them. They never carry a
 * variant cookie, so every bot hit would otherwise pile into the control arm and drag
 * its conversion rate down against a bot-free treatment arm.
 *
 * Exposure reporting must never break the page: an inactive experiment, a fingerprint
 * already bucketed into a different variant, and network failures all resolve quietly.
 */
export const recordExperimentExposure = async (
  experimentName: string,
  variantName: string,
): Promise<void> => {
  if (isbot(window.navigator.userAgent)) return;

  try {
    await API.post('/v1/ab-testing/trials/client-side', {
      experiment_name: experimentName,
      variant_name: variantName,
    });
  } catch (error) {
    console.debug('[ab-testing] could not record exposure', experimentName, error);
  }
};
